// extracted by mini-css-extract-plugin
export default {"container":"modal-search-image_container__wuZyg","content":"modal-search-image_content__WFpUh"};